/* ==========================================================================
   Empire Luxe — comportamento do tema
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Menu ---------- */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.getElementById('NavDrawer');
    if (!toggle || !drawer) return;
    toggle.addEventListener('click', function () {
      var aberto = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', aberto ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!drawer.contains(e.target) && !toggle.contains(e.target)) {
        drawer.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- Contador até a meia-noite ---------- */
  function initCountdown() {
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      // Relê a cada volta: o carrinho lateral é remontado e traz um contador novo
      var blocos = document.querySelectorAll('[data-countdown]');
      if (!blocos.length) return;
      var agora = new Date();
      var fim = new Date(agora);
      fim.setHours(24, 0, 0, 0);
      var resta = Math.max(0, fim - agora);
      var d = Math.floor(resta / 86400000);
      var h = Math.floor((resta % 86400000) / 3600000);
      var m = Math.floor((resta % 3600000) / 60000);
      var s = Math.floor((resta % 60000) / 1000);
      blocos.forEach(function (bloco) {
        var el;
        if ((el = bloco.querySelector('[data-cd-d]'))) el.textContent = pad(d);
        if ((el = bloco.querySelector('[data-cd-h]'))) el.textContent = pad(h);
        if ((el = bloco.querySelector('[data-cd-m]'))) el.textContent = pad(m);
        if ((el = bloco.querySelector('[data-cd-s]'))) el.textContent = pad(s);
        // Barra que esvazia ao longo do dia
        if ((el = bloco.querySelector('[data-cd-bar]'))) {
          el.style.width = ((resta / 86400000) * 100).toFixed(2) + '%';
        }
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Galeria ---------- */
  // Extraída para poder ser rechamada quando a galeria é recriada ao trocar de cor.
  function ligaMiniaturas() {
    var principal = document.getElementById('GalleryMain');
    var thumbs = document.querySelectorAll('[data-thumb]');
    if (!principal || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        principal.src = t.dataset.full;
        thumbs.forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  function initGallery() {
    ligaMiniaturas();
  }

  /* ---------- Mostra a foto da cor escolhida (página Vintage) ---------- */
  function mostraFotoDaVariante(idFoto, src, zoom) {
    if (!idFoto) return;

    // Computador: a foto grande vira a da cor escolhida
    var grande = document.querySelector('[data-vg-hero]');
    if (grande && src) {
      grande.src = src;
      var botao = grande.closest('.vg-hero');
      if (botao) {
        if (zoom) botao.dataset.zoom = zoom;
        botao.dataset.imageId = idFoto;
      }
    }

    // Celular: rola o carrossel até a foto daquela cor
    var trilho = document.querySelector('[data-vg-track]');
    if (!trilho) return;
    var itens = trilho.querySelectorAll('[data-image-id]');
    for (var i = 0; i < itens.length; i++) {
      if (itens[i].dataset.imageId === String(idFoto)) {
        trilho.scrollTo({ left: i * trilho.offsetWidth, behavior: 'smooth' });
        break;
      }
    }
  }

  /* ---------- Variantes (swatches) ---------- */
  function initVariants() {
    var swatches = document.querySelectorAll('[data-variant]');
    if (!swatches.length) return;
    var principal = document.getElementById('GalleryMain');
    var input = document.querySelector('[data-variant-input]');
    var preco = document.querySelector('[data-price]');
    var label = document.querySelector('[data-variant-label]');

    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        swatches.forEach(function (o) {
          o.classList.remove('is-active');
          o.setAttribute('aria-checked', 'false');
        });
        s.classList.add('is-active');
        s.setAttribute('aria-checked', 'true');

        // Quando a cor tem galeria própria (várias fotos), troca o conjunto
        // inteiro: foto grande e miniaturas. É o comportamento do site anterior.
        var galeria = window.EmpireVariantGallery && window.EmpireVariantGallery[s.dataset.variantId];
        var trilha = document.querySelector('[data-variant-thumbs]');
        if (galeria && galeria.length && principal && trilha) {
          principal.src = galeria[0];
          trilha.innerHTML = galeria.map(function (url, i) {
            return '<button type="button" class="' + (i === 0 ? 'is-active' : '') +
              '" data-thumb data-full="' + url + '" aria-label="Imagem ' + (i + 1) + '">' +
              '<img src="' + url + '" alt="" loading="lazy" width="200" height="200"></button>';
          }).join('');
          ligaMiniaturas();
        } else if (s.dataset.variantImage && principal) {
          // Sem galeria própria: mantém a troca simples pela imagem da variante
          principal.src = s.dataset.variantImage;
          document.querySelectorAll('[data-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t.dataset.full === s.dataset.variantImage);
          });
        }

        // Galeria da página Vintage: carrossel no celular, foto grande no computador
        mostraFotoDaVariante(s.dataset.variantImageId, s.dataset.variantImage, s.dataset.variantZoom);

        if (input) input.value = s.dataset.variantId;
        if (preco && s.dataset.variantPrice) preco.textContent = s.dataset.variantPrice;
        if (label) label.textContent = s.title;

        // Mantém os seletores de cor em sincronia com a cor escolhida
        ['[data-pick="0"]', '[data-pick="1"]'].forEach(function (sel) {
          var campo = document.querySelector(sel);
          if (!campo) return;
          campo.value = s.dataset.variantId;
          campo.dispatchEvent(new Event('change'));
        });

        // Atualiza a URL sem recarregar, para o link poder ser compartilhado
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', s.dataset.variantId);
          window.history.replaceState({}, '', url);
        } catch (e) { /* navegador antigo: ignora */ }
      });
    });
  }

  /* ---------- Escolha do bundle: escada de níveis ---------- */
  /* Cada nível carrega a própria quantidade e o próprio código de desconto nos
     data-attributes, então esta função serve para dois níveis ou vinte sem
     saber nada sobre a oferta. */
  function initEscada(niveis) {
    var qtd = document.querySelector('[data-quantity-input]');

    function seleciona(alvo) {
      niveis.forEach(function (n) {
        n.classList.toggle('is-active', n === alvo);
        n.classList.remove('precisa-escolha');
      });
      if (qtd) qtd.value = alvo.dataset.qty || '1';
    }

    niveis.forEach(function (n) {
      n.addEventListener('click', function () { seleciona(n); });
      n.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          // espaço dentro de um select é do select, não do cartão
          if (e.target.tagName === 'SELECT') return;
          e.preventDefault();
          seleciona(n);
        }
      });
    });

    /* Nenhum nível é marcado por conta própria. Quando a configuração do tema
       não define um nível de partida, a página abre com as duas opções neutras
       e a escolha é do cliente — antes daqui, o primeiro nível era marcado no
       carregamento e a página parecia já clicada. Quem garante que ninguém
       adiciona sem escolher é a trava em initAddToCart. */
  }

  /* ---------- Escolha do bundle ---------- */
  function initBundle() {
    var niveis = document.querySelectorAll('[data-bundle][data-qty]');
    if (niveis.length) { initEscada(niveis); return; }

    var single = document.querySelector('[data-bundle="single"]');
    var duo = document.querySelector('[data-bundle="duo"]');
    var qtd = document.querySelector('[data-quantity-input]');
    if (!single || !duo) return;

    var pickerSingle = document.querySelector('[data-single-picker]');

    function seleciona(escolha) {
      var eDuo = escolha === 'duo';
      duo.classList.toggle('is-active', eDuo);
      single.classList.toggle('is-active', !eDuo);
      if (qtd) qtd.value = eDuo ? '2' : '1';
      // O seletor de cor da opção de 1 relógio só aparece quando ela está escolhida
      if (pickerSingle) pickerSingle.hidden = eDuo;
    }
    single.addEventListener('click', function () { seleciona('single'); });
    duo.addEventListener('click', function (e) {
      // o botão verde interno tem ação própria (enviar direto)
      if (e.target.closest('.bundle-cta')) return;
      seleciona('duo');
    });
    duo.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); seleciona('duo'); }
    });

    var cta = duo.querySelector('.bundle-cta');
    if (cta) {
      cta.addEventListener('click', function () {
        seleciona('duo');
        var form = document.querySelector('[data-product-form]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  /* ---------- Miniaturas do "Pick 2 colors" ---------- */
  function initPickColors() {
    document.querySelectorAll('[data-pick]').forEach(function (sel) {
      var img = document.querySelector('[data-pick-img="' + sel.dataset.pick + '"]');
      function atualiza() {
        var opt = sel.options[sel.selectedIndex];
        if (img && opt && opt.dataset.image) img.src = opt.dataset.image;
      }
      sel.addEventListener('change', atualiza);
      atualiza();
    });
  }

  /* ---------- Envio do carrinho ---------- */
  function initAddToCart() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var botao = form.querySelector('[data-add-to-cart]');
      var textoOriginal = botao ? botao.textContent : '';

      /* ----- Escada sem escolha: não adivinha a quantidade -----
         Como nenhum nível vem marcado, o cliente pode chegar ao botão sem
         escolher. Adicionar um palpite mandaria para o carrinho uma quantidade
         que a página não anunciou. Pede a escolha e não envia nada. */
      var niveisEscada = document.querySelectorAll('[data-bundle][data-qty]');
      if (niveisEscada.length && !document.querySelector('[data-bundle][data-qty].is-active')) {
        niveisEscada.forEach(function (n) { n.classList.add('precisa-escolha'); });
        if (botao) {
          botao.textContent = 'SELECT AN OPTION ABOVE';
          setTimeout(function () { botao.textContent = textoOriginal; }, 2200);
        }
        niveisEscada[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }

      if (botao) { botao.disabled = true; botao.textContent = 'ADDING...'; }

      var itens = [];

      /* ----- Modo escada: o nível ativo diz tudo ----- */
      var ativo = document.querySelector('[data-bundle][data-qty].is-active');
      if (ativo) {
        var qtdNivel = parseInt(ativo.dataset.qty, 10) || 1;
        var picks = ativo.querySelectorAll('[data-pick]');
        var contagem = {};

        if (picks.length) {
          // Cores repetidas viram uma linha só com a quantidade somada
          picks.forEach(function (s) {
            contagem[s.value] = (contagem[s.value] || 0) + 1;
          });
        } else {
          contagem[form.querySelector('[data-variant-input]').value] = qtdNivel;
        }

        Object.keys(contagem).forEach(function (id) {
          itens.push({ id: Number(id), quantity: contagem[id] });
        });

        return enviaCarrinho(form, botao, textoOriginal, itens, ativo.dataset.code || null);
      }

      var duoEl = document.querySelector('[data-bundle="duo"]');
      var eDuo = duoEl ? duoEl.classList.contains('is-active') : false;

      if (eDuo) {
        var p1 = document.querySelector('[data-pick="1"]');
        var p2 = document.querySelector('[data-pick="2"]');
        if (p1 && p2) {
          // Duas cores distintas viram duas linhas; a mesma cor vira uma linha com 2 unidades
          if (p1.value === p2.value) {
            itens.push({ id: Number(p1.value), quantity: 2 });
          } else {
            itens.push({ id: Number(p1.value), quantity: 1 });
            itens.push({ id: Number(p2.value), quantity: 1 });
          }
        } else {
          itens.push({ id: Number(form.querySelector('[data-variant-input]').value), quantity: 2 });
        }
      } else {
        // Uma unidade: usa a cor do seletor da opção simples, quando existir
        var p0 = document.querySelector('[data-pick="0"]');
        var id = p0 ? p0.value : form.querySelector('[data-variant-input]').value;
        itens.push({ id: Number(id), quantity: 1 });
      }

      // O desconto do bundle vive num código de desconto da Shopify. Sem
      // aplicá-lo, o carrinho cobra o preço cheio e o cliente paga mais do
      // que viu na página. O código é aplicado antes de abrir o carrinho.
      var codigoBundle = eDuo
        ? (window.EmpireBundleCode || 'CASIOB1G1')
        : null;

      return enviaCarrinho(form, botao, textoOriginal, itens, codigoBundle);
    });
  }

  /* ---------- Envio ao carrinho, comum aos dois modos de oferta ---------- */
  function enviaCarrinho(form, botao, textoOriginal, itens, codigoBundle) {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itens, sections: 'cart-drawer' })
      })
        .then(function (r) { return r.json(); })
        .then(function (dados) {
          // O painel lateral precisa do preco JA com desconto. O endpoint
          // 'cart?sections=' NAO devolve a chave sections (devolve so o JSON do
          // carrinho) — o endpoint certo e a raiz com ?sections=. Bug identico
          // ja corrigido na pagina do Casio em 2026-08-05; aqui e o JS
          // compartilhado por TODOS os outros produtos, entao nunca tinha sido
          // testado com desconto real aplicado.
          function repinta() {
            return fetch(window.Shopify.routes.root + '?sections=cart-drawer', {
              headers: { 'Accept': 'application/json' },
            })
              .then(function (r) { return r.json(); })
              .then(function (novo) {
                if (novo && novo['cart-drawer']) dados.sections = novo;
                return dados;
              })
              .catch(function () { return dados; });
          }
          if (!codigoBundle) return repinta();
          // discount_code é aplicado via /discount/<code> e persiste no carrinho.
          return fetch(window.Shopify.routes.root + 'discount/' + encodeURIComponent(codigoBundle) + '?redirect=/cart.js', {
            method: 'GET',
            headers: { 'Accept': 'application/json' },
          })
            .then(function () { return repinta();
            })
            .catch(function () { return dados; });
        })
        .then(function (dados) {
          if (botao) { botao.disabled = false; botao.textContent = textoOriginal; }
          // Abre o carrinho lateral em vez de sair da página
          if (window.EmpireCart && window.EmpireCart.pronto()) {
            window.EmpireCart.pinta(dados.sections);
            window.EmpireCart.abre();
          } else {
            window.location.href = window.Shopify.routes.root + 'cart';
          }
        })
        .catch(function () {
          if (botao) { botao.disabled = false; botao.textContent = textoOriginal; }
          alert('Could not add to cart. Please try again.');
        });
  }

  /* ---------- Setas dos carrosséis ---------- */
  function initRails() {
    document.querySelectorAll('[data-rail-prev], [data-rail-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var rail = document.getElementById(btn.dataset.railTarget);
        if (!rail) return;
        var dir = btn.hasAttribute('data-rail-next') ? 1 : -1;
        rail.scrollBy({ left: dir * 560, behavior: 'smooth' });
      });
    });
  }

  /* ---------- Revelação ao rolar a página ---------- */
  function initReveal() {
    var alvos = document.querySelectorAll('[data-reveal]');
    if (!alvos.length) return;

    // Navegador antigo ou movimento reduzido: mostra tudo de uma vez
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      alvos.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.25 });

    alvos.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Carrossel de detalhes de design ---------- */
  function initDesignDetails() {
    document.querySelectorAll('[data-dd]').forEach(function (raiz) {
      var slides = raiz.querySelectorAll('[data-dd-slide]');
      if (slides.length < 2) return;
      var atual = 0;

      function mostra(proximo, direcao) {
        var entrando = direcao === 1 ? 'el-slide-right' : 'el-slide-left';
        slides[atual].hidden = true;
        atual = (proximo + slides.length) % slides.length;
        var slide = slides[atual];
        slide.hidden = false;

        slide.querySelectorAll('.dd-slide, .dd-caption').forEach(function (el) {
          // Reinicia a animação do zero: limpa, força o recálculo, devolve à regra do CSS
          el.style.animation = 'none';
          void el.offsetWidth;
          el.style.animation = '';
          // Só as imagens mudam de sentido; a legenda usa sempre o fade do CSS
          if (el.classList.contains('dd-slide')) el.style.animationName = entrando;
        });
      }

      raiz.addEventListener('click', function (e) {
        if (e.target.closest('[data-dd-prev]')) mostra(atual - 1, -1);
        if (e.target.closest('[data-dd-next]')) mostra(atual + 1, 1);
      });
    });
  }

  /* ---------- Carrossel de cartões (Inside Empire Luxe) ---------- */
  function initCards() {
    document.querySelectorAll('[data-cards]').forEach(function (raiz) {
      var trilho = raiz.querySelector('.cards-track');
      var prev = raiz.querySelector('[data-cards-prev]');
      var next = raiz.querySelector('[data-cards-next]');
      if (!trilho) return;

      var total = trilho.children.length;
      var i = 0;

      function visiveis() {
        var w = window.innerWidth;
        if (w >= 1024) return 3;
        if (w >= 640) return 2;
        return 1;
      }

      function aplica() {
        var v = visiveis();
        var maximo = Math.max(0, total - v);
        if (i > maximo) i = maximo;
        trilho.style.transform = 'translateX(-' + (i * 100) / v + '%)';
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i >= maximo;
      }

      if (prev) prev.addEventListener('click', function () { i = Math.max(0, i - 1); aplica(); });
      if (next) next.addEventListener('click', function () {
        i = Math.min(Math.max(0, total - visiveis()), i + 1);
        aplica();
      });

      var timer;
      window.addEventListener('resize', function () {
        clearTimeout(timer);
        timer = setTimeout(aplica, 150);
      });
      aplica();
    });
  }

  /* ---------- Coleções no celular: miniatura troca o destaque ---------- */
  function initCollectionsMobile() {
    document.querySelectorAll('[data-col-mobile]').forEach(function (raiz) {
      var destaque = raiz.querySelector('[data-col-feature]');
      var img = destaque && destaque.querySelector('img');
      if (!destaque || !img) return;

      // O rótulo do link continua fixo ("View All"), como no site
      raiz.querySelectorAll('[data-col-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          img.src = btn.dataset.image;
          img.alt = btn.dataset.title;
          destaque.href = btn.dataset.url;
        });
      });
    });
  }

  /* ---------- Galeria do produto Vintage (celular) ---------- */
  function initVintageGallery() {
    var trilho = document.querySelector('[data-vg-track]');
    if (!trilho) return;
    var thumbs = document.querySelectorAll('[data-vg-thumb]');
    var dots = document.querySelectorAll('[data-vg-dot]');

    function marca(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }

    var timer;
    trilho.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var largura = trilho.offsetWidth;
        if (largura) marca(Math.round(trilho.scrollLeft / largura));
      }, 60);
    });

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        trilho.scrollTo({ left: i * trilho.offsetWidth, behavior: 'smooth' });
        marca(i);
      });
    });

    marca(0);
  }

  /* ---------- Lightbox ---------- */
  function initLightbox() {
    var caixa = document.getElementById('Lightbox');
    if (!caixa) return;
    var foto = caixa.querySelector('img');
    var contador = caixa.querySelector('.count');
    var gatilhos = document.querySelectorAll('[data-zoom]');
    if (!gatilhos.length) return;

    var atual = 0;

    // Lê o endereço na hora de abrir: a foto grande muda quando o cliente troca de cor
    function pinta() {
      foto.src = gatilhos[atual].dataset.zoom;
      if (contador) contador.textContent = (atual + 1) + ' / ' + gatilhos.length;
    }
    function abre(i) {
      atual = i;
      pinta();
      caixa.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function fecha() {
      caixa.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    function anda(passo) {
      atual = (atual + passo + gatilhos.length) % gatilhos.length;
      pinta();
    }

    gatilhos.forEach(function (g, i) {
      g.addEventListener('click', function () { abre(i); });
    });

    caixa.addEventListener('click', function (e) {
      if (e.target.closest('[data-lb-prev]')) { e.stopPropagation(); anda(-1); return; }
      if (e.target.closest('[data-lb-next]')) { e.stopPropagation(); anda(1); return; }
      if (e.target.closest('[data-lb-close]') || e.target === caixa) fecha();
    });

    document.addEventListener('keydown', function (e) {
      if (!caixa.classList.contains('is-open')) return;
      if (e.key === 'Escape') fecha();
      if (e.key === 'ArrowLeft') anda(-1);
      if (e.key === 'ArrowRight') anda(1);
    });
  }

  /* ---------- Barra fixa de compra ---------- */
  function initStickyBar() {
    var barra = document.getElementById('StickyBar');
    var alvo = document.getElementById('BuyBox');
    if (!barra || !alvo || !('IntersectionObserver' in window)) return;

    // Aparece quando o botão de compra sai da tela por cima
    var io = new IntersectionObserver(function (entradas) {
      var e = entradas[0];
      var passou = !e.isIntersecting && e.boundingClientRect.top < 0;
      barra.classList.toggle('is-in', passou);
      barra.setAttribute('aria-hidden', passou ? 'false' : 'true');
    }, { threshold: 0 });

    io.observe(alvo);
  }

  /* ---------- Faixa de garantias no celular ---------- */
  function initTrustCarousel() {
    var raiz = document.querySelector('[data-trust]');
    if (!raiz) return;
    var slides = raiz.querySelectorAll('[data-trust-slide]');
    var dots = raiz.querySelectorAll('[data-trust-dot]');
    if (slides.length < 2) return;

    var i = 0;
    var relogio;

    function mostra(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-in', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-in', k === i); });
    }
    function anda() { mostra(i + 1); }
    function liga() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      relogio = setInterval(anda, 2500);
    }
    function desliga() { clearInterval(relogio); }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { desliga(); mostra(k); liga(); });
    });

    // Não fica girando com a aba em segundo plano
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) desliga(); else liga();
    });

    liga();
  }

  /* ---------- Carrinho lateral ---------- */
  function initCartDrawer() {
    var gaveta = document.querySelector('[data-cart-drawer]');
    if (!gaveta) return;

    var painel = gaveta.querySelector('.cd-panel');
    var interno = gaveta.querySelector('[data-cart-inner]');
    var ultimoFoco = null;

    function abre() {
      ultimoFoco = document.activeElement;
      gaveta.classList.add('is-open');
      gaveta.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var fechar = gaveta.querySelector('[data-cart-close]');
      if (fechar) fechar.focus();
    }
    function fecha() {
      gaveta.classList.remove('is-open');
      gaveta.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    }

    // Troca o conteúdo pelo HTML que a Shopify devolve, sem recarregar a página
    function pinta(sections) {
      if (!sections || !sections['cart-drawer']) return;
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var novoInterno = doc.querySelector('[data-cart-inner]');
      var novoSub = doc.querySelector('[data-cart-subtitle]');
      if (novoInterno) interno.innerHTML = novoInterno.innerHTML;

      var sub = gaveta.querySelector('[data-cart-subtitle]');
      if (sub && novoSub) sub.textContent = novoSub.textContent.trim();

      // Atualiza o número ao lado do ícone do carrinho
      var conta = doc.querySelector('[data-cart-count]');
      var alvo = document.querySelector('[data-cart-count]');
      if (alvo && conta) alvo.textContent = conta.textContent.trim();
      else if (alvo) atualizaContagem();
    }

    function atualizaContagem() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var alvo = document.querySelector('[data-cart-count]');
          if (alvo) alvo.textContent = c.item_count;
        })
        .catch(function () { /* sem rede: deixa como está */ });
    }

    // Cliques entram numa fila em vez de virar uma chamada cada. Quatro toques
    // rápidos no "+" viram um único pedido de +4, e nenhum toque se perde.
    // Antes, cada clique mandava a mesma quantidade calculada na tela anterior:
    // a rajada toda valia por um só, e o botão parecia morto.
    var fila = {};
    var timerFila = null;
    var enviando = false;

    // A fila é indexada pelo PRODUTO (variante), não pela linha do carrinho.
    // O Buy X Get Y reparte a mesma variante em várias linhas (parte paga,
    // parte grátis) e refaz a divisão a cada alteração: chave de linha colhida
    // na renderização vira pó entre um clique e o seguinte.
    //
    // Ordem de preferência: variante > chaves da linha > índice. O índice é o
    // resgate para HTML vindo de cache antigo, sem os atributos novos — sem ele
    // o clique morria em silêncio ("clico e não apaga").
    function refDe(el) {
      if (el.dataset.variant) return 'v' + el.dataset.variant;
      if (el.dataset.keys) return 'k' + el.dataset.keys;
      if (el.dataset.key) return 'k' + el.dataset.key;
      var idx = el.dataset.cartRemove || el.dataset.cartQty;
      return idx ? '#' + idx : '';
    }

    function agenda(el, passo, remover) {
      var ref = refDe(el);
      if (!ref || ref === '#' || ref === '#NaN' || ref === '#undefined') return;
      var anterior = fila[ref];
      var acumulado = !remover && anterior && !anterior.zerar ? anterior.passo : 0;
      fila[ref] = {
        variante: el.dataset.variant || null,
        chaves: (el.dataset.keys || el.dataset.key || '').split(',').filter(Boolean),
        indice: Number(el.dataset.cartRemove || el.dataset.cartQty) || 0,
        zerar: !!remover,
        passo: remover ? 0 : acumulado + passo
      };
      clearTimeout(timerFila);
      timerFila = setTimeout(descarrega, 250);
    }

    // Apaga a linha na hora do clique. As duas idas ao servidor levam perto de
    // um segundo; sem isto a lixeira parece morta nesse intervalo.
    function marcaSaindo(el) {
      var li = el.closest('[data-cd-item]');
      if (li) li.classList.add('is-removing');
    }

    function descarrega() {
      if (enviando) { timerFila = setTimeout(descarrega, 150); return; }
      var chaves = Object.keys(fila);
      if (!chaves.length) return;
      var lote = fila;
      fila = {};
      enviando = true;
      painel.setAttribute('aria-busy', 'true');

      // Uma chave por vez, cada uma relendo o carrinho: a primeira alteração
      // pode reagrupar as linhas e mudar a quantidade das seguintes.
      var cadeia = Promise.resolve(null);
      chaves.forEach(function (chave) {
        cadeia = cadeia.then(function () {
          return muda(lote[chave]);
        });
      });

      return cadeia
        .then(function (dados) {
          if (dados && dados.sections) pinta(dados.sections);
          else recarregaGaveta();
          atualizaContagem();
        })
        .catch(function () { alert('Could not update the cart. Please try again.'); })
        .then(function () {
          enviando = false;
          painel.removeAttribute('aria-busy');
          if (Object.keys(fila).length) descarrega();
        });
    }

    // Reúne TODAS as linhas que representam o produto e mexe nelas de uma vez.
    //
    // O Buy X Get Y reparte a variante em parte paga e parte grátis, cada uma
    // com sua chave. Mexendo numa só, o produto continuava na tela e o total
    // não mudava — o cliente lia isso como "o botão não funciona". A identidade
    // que sobrevive à divisão é a VARIANTE, então é por ela que a busca começa.
    //
    // A quantidade final sai da soma do passo com o que o carrinho tem AGORA,
    // lido na hora. O botão nunca manda um valor calculado numa tela velha.
    function muda(pedido) {
      return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (carrinho) {
          var alvos = [];
          var atual = 0;

          for (var i = 0; i < carrinho.items.length; i++) {
            var linha = carrinho.items[i];
            var bate;
            if (pedido.variante) bate = String(linha.variant_id) === String(pedido.variante);
            else if (pedido.chaves.length) bate = pedido.chaves.indexOf(linha.key) > -1;
            else bate = i + 1 === pedido.indice; // HTML antigo, só com o índice
            if (bate) { alvos.push(linha); atual += linha.quantity; }
          }

          // Sumiu (o desconto reagrupou, ou outra aba mexeu): só repinta.
          if (!alvos.length) return null;

          var destino = pedido.zerar ? 0 : Math.max(0, atual + pedido.passo);
          if (!pedido.zerar && destino === atual) return null;

          // Um único pedido para todas as partes. Em chamadas separadas, a
          // Shopify refaz a divisão paga/grátis entre uma e outra e a segunda
          // erra o alvo — era assim que sobrava metade do produto na tela.
          var updates = {};
          alvos.forEach(function (linha, n) {
            updates[linha.key] = n === 0 ? destino : 0;
          });

          return fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates, sections: 'cart-drawer' })
          }).then(function (r) { return r.json(); });
        });
    }

    // Repinta a gaveta a partir do servidor quando não veio seção na resposta.
    function recarregaGaveta() {
      return fetch(window.Shopify.routes.root + '?sections=cart-drawer', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (secoes) { pinta(secoes); })
        .catch(function () { /* sem rede: deixa como está */ });
    }

    // Abrir pelo ícone do cabeçalho.
    // Na fase de captura, para rodar antes de qualquer outro clique da página.
    document.addEventListener('click', function (e) {
      var gatilho = e.target.closest ? e.target.closest('[data-cart-open]') : null;
      if (!gatilho) return;
      e.preventDefault();
      e.stopPropagation();
      abre();
    }, true);

    // Reforço: liga direto no elemento, caso algo interrompa a delegação
    document.querySelectorAll('[data-cart-open]').forEach(function (el) {
      if (el.dataset.cartBound) return;
      el.dataset.cartBound = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        abre();
      });
    });

    // Fechar, mexer na quantidade e remover
    gaveta.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) {
        var link = e.target.closest('a[data-cart-close]');
        if (!link) e.preventDefault();
        fecha();
        return;
      }
      var qtd = e.target.closest('[data-cart-qty]');
      if (qtd) {
        var visorQtd = qtd.parentNode.querySelector('[data-cd-qty]') || qtd.parentNode.querySelector('span');
        var atualVisor = Number((visorQtd && visorQtd.textContent.trim()) || 0);
        // `data-step` é o formato novo; `data-to` é o antigo (quantidade final).
        var passo = qtd.dataset.step
          ? Number(qtd.dataset.step)
          : (Number(qtd.dataset.to) - atualVisor);
        if (!passo) return;

        // Número muda no clique, não quando a rede responde. Sem isso a rajada
        // parece ignorada mesmo com a fila funcionando por baixo.
        var novo = Math.max(0, atualVisor + passo);
        if (visorQtd) visorQtd.textContent = novo;
        if (novo === 0) marcaSaindo(qtd);
        agenda(qtd, passo, false);
        return;
      }
      var remove = e.target.closest('[data-cart-remove]');
      if (remove) {
        marcaSaindo(remove);
        agenda(remove, 0, true);
        return;
      }
      var pagar = e.target.closest('[data-cart-checkout]');
      if (pagar) pagar.classList.add('is-busy');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && gaveta.classList.contains('is-open')) fecha();
    });

    window.EmpireCart = {
      abre: abre,
      fecha: fecha,
      pinta: pinta,
      pronto: function () { return true; }
    };
  }

  /* ---------- Rastreio do pedido ---------- */
  function initTrackForm() {
    var forma = document.querySelector('[data-track-form]');
    if (!forma) return;
    forma.addEventListener('submit', function (e) {
      e.preventDefault();
      var campo = forma.querySelector('input[name="nums"]');
      var codigo = (campo.value || '').trim().replace(/\s+/g, '');
      if (!codigo) { campo.focus(); return; }
      // Abre o rastreamento numa aba nova, sem tirar o cliente da loja
      window.open(forma.dataset.endpoint + encodeURIComponent(codigo), '_blank', 'noopener');
    });
  }

  function init() {
    if (!window.Shopify) window.Shopify = { routes: { root: '/' } };
    if (!window.Shopify.routes) window.Shopify.routes = { root: '/' };
    initCartDrawer();
    initMenu();
    initCountdown();
    initGallery();
    initVariants();
    initBundle();
    initPickColors();
    initAddToCart();
    initRails();
    initReveal();
    initDesignDetails();
    initCards();
    initCollectionsMobile();
    initVintageGallery();
    initLightbox();
    initStickyBar();
    initTrustCarousel();
    initTrackForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
